// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';

const useStyles = makeStyles(theme => ({
  palette: {
    width: '100%',
    display: 'flex',
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  textColor: {
    textAlign: 'left',
    fontWeight: 600,
    fontSize: 14,
    color: colors.grey900,
  },
  secondaryColor: {
    color: colors.grey700,
    fontWeight: 500,
    fontSize: 12,
  },
  rectangle: {
    height: 75,
    width: '100%',
    borderRadius: 4,
    padding: theme.spacing(2, 1.5),
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  rectangleFirstText: {
    fontSize: '14px',
    fontWeight: 500,
    marginRight: theme.spacing(2),
    color: '#3A3A49',
  },
  rectangleSecondText: {
    fontWeight: 500,
    fontSize: '12px',
    color: '#3A3A49',
  },
  verticalDivider: {
    backgroundColor: colors.grey300,
    height: '4rem',
    margin: theme.spacing(0, 2),
  },
  box: {
    margin: theme.spacing(1, 0),
  },
  inputColor: {
    appearance: 'none',
    '-moz-appearance': 'none',
    '-webkit-appearance': 'none',
    background: 'none',
    border: '0',
    cursor: 'pointer',
    height: '40px',
    padding: '0',
    width: '40px',
  },
  colorWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  select: {
    height: 50,
  },
  previewColor: {
    color: colors.grey900,
    fontSize: 16,
    width: 24,
    height: 24,
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
  itemSelectFontColor: {
    display: 'flex',
    alignItems: 'center',
  },
}));

type Props = {
  errors?: {[key: string]: any},
  name: string,
  register: any => void,
  backgroundColor?: string,
  setValue: (name: string, value: any) => void,
  arrayTextColors: {name: string, hex: string}[],
  textColor?: string,
  defaultTextColor?: string,
  setTextColor: (val: string) => void,
};

export default function ColorVisualizer(props: Props) {
  const {
    errors,
    setValue,
    name,
    register,
    backgroundColor,
    arrayTextColors,
    textColor,
    setTextColor,
    defaultTextColor,
  } = props;

  const classes = useStyles();

  const buildPrevisualization = (bgColor?: string, textColor?: string) => {
    return (
      <div className={classes.rectangle} style={{backgroundColor: bgColor}}>
        <Typography
          className={classes.rectangleFirstText}
          style={{color: textColor}}
        >
          Aa
        </Typography>
        <Typography
          className={classes.rectangleSecondText}
          style={{color: textColor}}
        >
          Color de texto
        </Typography>
      </div>
    );
  };

  const handleFontColorChange = event => {
    if (event) {
      setTextColor(event.target.value);
    }
  };

  return (
    <div className={classes.palette}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          <div>
            <Typography className={classes.textColor}>
              Color de fondo
            </Typography>
            <div className={classes.box}>
              <Typography className={classes.secondaryColor}>
                Código Hex
              </Typography>
            </div>
            <Grid container alignItems="center">
              <Grid xs={2} md={4}>
                <input
                  type="color"
                  value={backgroundColor}
                  onChange={e => setValue(name, e.target.value)}
                  className={classes.inputColor}
                />
              </Grid>
              <Grid item xs={10} md={8}>
                <CustomTextField
                  name={name}
                  error={errors && errors[name]}
                  helperText={
                    errors && errors[name] ? errors[name].message : ''
                  }
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^#(?:[0-9a-fA-F]{3}){1,2}$/,
                      message: 'Formato de color inválido',
                    },
                  })}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12} md={4}>
          <div>
            <Typography className={classes.textColor}>
              Color de texto
            </Typography>
            <div className={classes.box}>
              <Typography className={classes.secondaryColor}>
                Selecciona un color
              </Typography>
            </div>
            <Select
              fullWidth
              className={classes.select}
              defaultValue={defaultTextColor}
              onChange={handleFontColorChange}
              // disabled={true}
            >
              {arrayTextColors.map((el, idx) => (
                <MenuItem
                  key={'text-color-' + idx}
                  value={el.hex}
                  className={classes.itemSelectFontColor}
                >
                  {/* <div
                    className={classes.previewColor}
                    style={{background: el.hex}}
                  /> */}
                  <Typography>{el.name}</Typography>
                </MenuItem>
              ))}
            </Select>
          </div>
        </Grid>
        <Grid item xs={12} md={4}>
          <div>
            <Typography className={classes.textColor}>
              Previsualización
            </Typography>
            <div className={classes.box}>
              {buildPrevisualization(backgroundColor, textColor)}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

ColorVisualizer.propTypes = {
  errors: PropTypes.object,
  name: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
  arrayTextColors: PropTypes.array.isRequired,
  textColor: PropTypes.string,
  defaultTextColor: PropTypes.string,
  setTextColor: PropTypes.func.isRequired,
};
